var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHamburger = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 18,
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 1h14M1 9h14M1 17h14"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHamburger);
export default ForwardRef;